import toast from "react-hot-toast";

export const validateFile = (file, type) => {
    const allowedImageTypes = ["image/jpeg", "image/jpg", "image/png", "image/svg+xml", "image/webp"];
    const maxImageSize = 2 * 1024 * 1024; // 2MB
    const maxVideoSize = 10 * 1024 * 1024; // 10MB

    if (type === "image") {
        const isSvg = file.type === "image/svg+xml" || file.name.toLowerCase().endsWith(".svg");
        if (!allowedImageTypes.includes(file.type) && !isSvg) {
            toast.error(`${file.name} is not a valid format. Only JPG, JPEG, PNG, and SVG are allowed.`);
            return false;
        }
        if (file.size > maxImageSize) {
            toast.error(`${file.name} exceeds 2MB limit.`);
            return false;
        }
    } else if (type === "video") {
        if (!file.type.startsWith("video/")) {
            toast.error(`${file.name} is not a valid video file.`);
            return false;
        }
        if (file.size > maxVideoSize) {
            toast.error(`${file.name} exceeds 10MB limit.`);
            return false;
        }
    }
    return true;
};